import { Input } from '@/components/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Button } from '@/components/ui/button';
import { Search, X } from 'lucide-react';

interface OrganizationFiltersProps {
  search: string;
  onSearchChange: (value: string) => void;
  includeDeleted: string;
  onIncludeDeletedChange: (value: string) => void;
  subscribed: string;
  onSubscribedChange: (value: string) => void;
  dateRange: string;
  onDateRangeChange: (value: string) => void;
  onReset: () => void;
}

export function OrganizationFilters({
  search,
  onSearchChange,
  includeDeleted,
  onIncludeDeletedChange,
  subscribed,
  onSubscribedChange,
  dateRange,
  onDateRangeChange,
  onReset,
}: OrganizationFiltersProps) {
  const hasActiveFilters =
    search || includeDeleted !== 'false' || subscribed !== 'all' || dateRange !== 'all';

  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
      <div className="relative flex-1 max-w-sm">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
        <Input
          placeholder="Search organizations..."
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          className="pl-10"
        />
      </div>

      <div className="flex flex-wrap gap-2">
        <Select value={includeDeleted} onValueChange={onIncludeDeletedChange}>
          <SelectTrigger className="w-[140px]">
            <SelectValue placeholder="Status" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="false">Active Only</SelectItem>
            <SelectItem value="true">Include Deleted</SelectItem>
          </SelectContent>
        </Select>

        <Select value={subscribed} onValueChange={onSubscribedChange}>
          <SelectTrigger className="w-[120px]">
            <SelectValue placeholder="Plan" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Plans</SelectItem>
            <SelectItem value="true">Paid</SelectItem>
            <SelectItem value="false">Free</SelectItem>
          </SelectContent>
        </Select>

        <Select value={dateRange} onValueChange={onDateRangeChange}>
          <SelectTrigger className="w-[120px]">
            <SelectValue placeholder="Date" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Time</SelectItem>
            <SelectItem value="7d">Last 7 Days</SelectItem>
            <SelectItem value="30d">Last 30 Days</SelectItem>
            <SelectItem value="90d">Last 90 Days</SelectItem>
          </SelectContent>
        </Select>

        {hasActiveFilters && (
          <Button variant="ghost" size="sm" onClick={onReset} className="h-10">
            <X className="h-4 w-4 mr-1" />
            Reset
          </Button>
        )}
      </div>
    </div>
  );
}
